const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							type="text"
							class="input {~ColumnAlignment:Record~}"
							placeholder="{~Placeholder:Record~}"
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
							autocomplete="off"
							value=""
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntityDisplay',
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
						autocomplete="off"
						value=""
					/>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<div
					id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			Template: /*HTML-Partial*/`
				></div>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
